import i18n from '../../../i18n';
import { RoleType } from '../../../interfaces';
import { Source } from '../../../queries/ats/titles/types/sources';
import { Title } from '../../../queries/ats/titles/types/title';

export class Metadata {
  public static build(title: Title, source: Source) {
    return {
      actors: this.actors(title),
      directors: this.directors(title),
      producers: this.producers(title),
      details: [
        {
          label: i18n.t('details:original-title'),
          value: title.originalTitle,
        },
        {
          label: i18n.t('details:audio-languages'),
          value: this.audioLanguages(source).join(', '),
        },
        {
          label: i18n.t('details:distributor'),
          value: source.distributor,
        },
        {
          label: i18n.t('details:subtitle-languages'),
          value: this.subtitleLanguages(source).join(', '),
        },
        {
          label: i18n.t('details:altibox-id'),
          value: source.providerTitleId,
        },
        {
          label: i18n.t('details:master-id'),
          value: title.masterId,
        },
      ],
    };
  }

  public static actors(title: Title) {
    return title.cast.filter((member) => member.role === RoleType.CAST_MEMBER || member.role === RoleType.ACTOR);
  }

  public static directors(title: Title) {
    return title.cast.filter((member) => member.role === RoleType.DIRECTOR);
  }

  public static producers(title: Title) {
    return title.cast.filter((member) => member.role === RoleType.PRODUCER);
  }

  public static audioLanguages(source: Source) {
    return source.languages.filter((lang) => lang.type === 'audio').map((lang) => lang.label) ?? [];
  }

  public static subtitleLanguages(source: Source) {
    return source.languages.filter((lang) => lang.type === 'subtitle').map((lang) => lang.label) ?? [];
  }
}
